module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0017_15_D18_1.585f8c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0017_15_D18_1.jpg
// module id = zrEx
// module chunks = 0